<template>
    <div>
        <div>
            <h2>เพิ่มบัญชี</h2>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>ประเภทบัญชี</label>
                </b-col>
                <b-col sm="6">
                    <b-form-select :options="account_type"
                                   :disabled="disabledSelect"
                                   @input="generatePaymentAccountNumber(form.account_type)"
                                   v-model="form.account_type">
                    </b-form-select>
                </b-col>
            </b-row>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>รหัสบัญชี</label>
                </b-col>
                <b-col sm="6">
                    <input v-model="form.account"
                           disabled
                           class="form-control"
                           type="text"/></b-col>
            </b-row>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>ชื่อบัญชี</label>
                </b-col>
                <b-col sm="6">
                    <input v-model="form.name"
                           class="form-control"
                           type="text"/></b-col>
            </b-row>
        </div>
        <br/>
        <div class="col text-center">
            <button @click="submitAccount"
                    type="button"
                    :disabled="!form.name"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>
            &nbsp&nbsp
            <button @click="cancelAccount"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <!--        <pre class="alert-primary">{{account_type}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "add-account-modal",
    props: {
        account_menu: '',
    },
    created() {
        this.$store.dispatch("Account/getPaymentAccountType");
    },
    data() {
        return {}
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Account.paymentAccountForm
            },
            account_type: state => {
                return [
                    {
                        value: null,
                        text: "ประเภทบัญชี"
                    },
                    ...state.Account.paymentAccountType.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            }
        }),
        disabledSelect() {
            return !!(this.form.id || this.account_menu == 'income');
        }
    },
    methods: {
        generatePaymentAccountNumber(account_id) {
            //console.log(account_id);
            if (account_id && !this.form.id) {
                this.$store.dispatch("Account/generatePaymentAccountNumber", account_id).then(res => {
                    this.form.account = res;
                })
            }
        },
        submitAccount() {
            this.$emit("submit", this.form);
        },
        cancelAccount() {
            this.$emit("submit", false);
        }
    }
}
</script>

<style scoped>

</style>
